// Substring match: cmdk's default fuzzy scoring surfaces noise ("omar" → "Roman Roy").
export const substringFilter = (value: string, search: string, keywords?: string[]) =>
  `${value} ${keywords?.join(' ') ?? ''}`.toLowerCase().includes(search.trim().toLowerCase())
    ? 1
    : 0;
